module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_3009.9d6bcbf9.png";